export const PedestrianWalking = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.5" cy="4.5" r="2.5" stroke="currentColor" stroke-width="2"/>
<path d="M8 18V13L12.525 10.285C12.8358 10.0985 13.1915 10 13.554 10H17.6459C18.4637 10 19.1992 10.4979 19.5029 11.2572L21 15H26" stroke="currentColor" stroke-width="2"/>
<path d="M13.0004 10V24L9.37598 29.4563" stroke="currentColor" stroke-width="2"/>
<path d="M18 18L20 24V30" stroke="currentColor" stroke-width="2"/>
</svg>`;
